<template>
  <VDropdown
    theme="info-tooltip"
    :triggers="['hover']"
    :popperTriggers="['hover']"
    :delay="{ show: 300, hide: 100 }"
    @show="loadReactors"
  >
    <button
      type="button"
      class="reaction-bubble"
      data-cy="reaction-bubble"
      :class="{ 'reaction-bubble--own': hasReacted }"
      @click.stop="toggleReaction"
      :disabled="loading"
    >
      <span class="reaction-bubble__emoji">{{ emoji }}</span>
      <span class="reaction-bubble__count">{{ count }}</span>
    </button>
    <template v-slot:popper>
      <div class="reaction-detail">
        <div v-if="loadingReactors" class="reaction-detail__loading">
          <spinner :inline="true"></spinner>
        </div>
        <div v-else-if="reactors.length > 0">
          <p class="reaction-detail__header">{{ emoji }}</p>
          <ul class="reaction-detail__list">
            <li v-for="reactor in reactors" :key="reactor.id" class="reaction-detail__item">
              {{ reactor.profile.display_name }}
            </li>
          </ul>
        </div>
      </div>
    </template>
  </VDropdown>
</template>

<script>
import Spinner from './spinner.vue';

export default {
  name: 'reaction-bubble',
  components: { Spinner },
  props: {
    emoji: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    messageId: {
      type: Number,
      required: true,
    },
    hasReacted: {
      type: Boolean,
      default: false,
    },
    userReactionId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      loadingReactors: false,
      reactors: [],
      reactorsLoaded: false,
    };
  },
  methods: {
    toggleReaction() {
      if (this.loading) return;

      this.loading = true;
      if (this.hasReacted && this.userReactionId) {
        this.removeReaction();
      } else {
        this.addReaction();
      }
    },
    addReaction() {
      const url = this.$apiService.messageReactionsUrl(this.messageId);
      const params = {
        message_reaction: {
          emoji: this.emoji,
        },
      };

      axios.post(url, params)
        .then((response) => {
          this.loading = false;
          this.$emit('reaction-added', {
            emoji: this.emoji,
            reactionId: response.data.id,
          });
          this.reactorsLoaded = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notificationManager.emit('show-toast', 'Unable to add reaction', false);
        });
    },
    removeReaction() {
      const url = this.$apiService.messageReactionUrl(this.messageId, this.userReactionId);

      axios.delete(url)
        .then(() => {
          this.loading = false;
          this.$emit('reaction-removed', {
            emoji: this.emoji,
          });
          this.reactorsLoaded = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notificationManager.emit('show-toast', 'Unable to remove reaction', false);
        });
    },
    loadReactors() {
      if (this.reactorsLoaded || this.loadingReactors) return;

      this.loadingReactors = true;
      const url = `${this.$apiService.messageReactionsUrl(this.messageId)}?emoji=${encodeURIComponent(this.emoji)}`;

      axios.get(url)
        .then((response) => {
          this.reactors = response.data.reactions || [];
          this.reactorsLoaded = true;
          this.loadingReactors = false;
        })
        .catch((error) => {
          this.loadingReactors = false;
        });
    },
  },
};
</script>
